import { Card } from '../base/Card';
import { ReadingTableRow } from './LiveReadingTable/ReadingTableRow';
import { IDataPoint } from '../../types/DataPoint/DataPoint';

interface ReadingsTableProps {
  dataPoints: IDataPoint[];
}

export function ReadingsTable({ dataPoints }: ReadingsTableProps) {
  return (
    <Card>
      <div className="block overflow-x-auto overflow-y-hidden">
        <table className="min-w-full table border border-primary/40 divide-y divide-primary dark:border-primary">
          <thead className="bg-primary/40">
            <tr>
              <th className="w-6/8 px-3 py-3 text-left text-sm font-semibold">
                Name
              </th>
              <th className="w-1/8 px-3 py-3 text-left text-sm font-semibold">
                Manufacturer Reference
              </th>
              <th className="w-1/8 px-3 py-3 text-left text-sm font-semibold">
                Value
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-primary/40">
            {dataPoints.map((dp, i) => (
              <ReadingTableRow key={dp.id} dataPoint={dp} rowIndex={i} />
            ))}
          </tbody>
        </table>
      </div>
    </Card>
  );
}
